export class GestorCadastro {

    constructor(
        public nome: string,
        public cpf: string,
        public telefoneNumero: string,
        public dataNascimento: any,
        public email: string,
        public senha: string,
        public emailConfirmacao: string,
        public senhaConfirmacao: string,
        public perfisId: number[],
        public appKey: string
    ) {
    }
    
    public companyName: string;
    public numberOfEmployees: string;
}

export class AssignorLead {
    constructor(
        public companyName: string,
        public numberOfEmployees: string,
        public name: string,
        public document: string,
        public phone: number,
        public birthDate: any,
        public email: string,
        public confirmationEmail: string,
    ) {}
}